export const intersect = (a: any, b: any) => {
  const setA: any = new Set(a);
  const setB: any = new Set(b);
  const intersection = new Set([...setA].filter((x) => setB.has(x)));
  return Array.from(intersection);
};
